import ApiService from './api'

const OAUTH_CLIENTS_URL = `${window.location.origin}/oauth/clients`
const OAUTH_TOKENS_URL = `${window.location.origin}/oauth/tokens`

export const ClientsService = {
    getClients() {
        return ApiService.get(OAUTH_CLIENTS_URL)
    },

    putClients(params = {}) {
        return ApiService.post(OAUTH_CLIENTS_URL, params)
    },

    delClients(id) {
        return ApiService.delete(`${OAUTH_CLIENTS_URL}/${id}`)
    },

    updateClients(id, params) {
        return ApiService.put(`${OAUTH_CLIENTS_URL}/${id}`, params)
    },
}

export const TokensService = {
    getTokens() {
        return ApiService.get(OAUTH_TOKENS_URL)
    },

    delTokens(id) {
        return ApiService.delete(`${OAUTH_TOKENS_URL}/${id}`)
    },
}
